// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ni-0";
export var fileList = "_ni-2";
export var removeFileButton = "_ni-1";